export enum EVENTS {
  'test_start' = 'test_start',
  'test_end' = 'test_end',
  'feedback_prompt_shown' = 'feedback_prompt_shown',
  'feedback_prompt_submitted' = 'feedback_prompt_submitted',
  'feedback_prompt_snoozed' = 'feedback_prompt_snoozed',
  'feedback_prompt_dismissed_forever' = 'feedback_prompt_dismissed_forever',
}

export type EVENT = keyof typeof EVENTS
